export type Point = { x: number; y: number };
/** Monotone cubic interpolation: smooth corners without inventing peaks. */
export function smoothLine(points: Point[]) {
  if (!points.length) return "";
  const start = `M ${points[0]!.x},${points[0]!.y}`;
  if (points.length < 2) return start;
  const slopes = points
    .slice(1)
    .map((p, i) => (p.y - points[i]!.y) / (p.x - points[i]!.x));
  const tangents = points.map((_p, i) => {
    if (i === 0) return slopes[0]!;
    if (i === points.length - 1) return slopes.at(-1)!;
    const a = slopes[i - 1]!,
      b = slopes[i]!;
    return a * b <= 0 ? 0 : (2 * a * b) / (a + b);
  });
  for (let i = 0; i < slopes.length; i++) {
    const s = slopes[i]!;
    if (s === 0) {
      tangents[i] = 0;
      tangents[i + 1] = 0;
      continue;
    }
    const a = tangents[i]! / s,
      b = tangents[i + 1]! / s,
      length = Math.hypot(a, b);
    if (length > 3) {
      tangents[i] = (3 * a * s) / length;
      tangents[i + 1] = (3 * b * s) / length;
    }
  }
  return (
    start +
    points
      .slice(1)
      .map((p, i) => {
        const before = points[i]!,
          // Longer handles and gentler tangents soften transitions, including
          // two-point sections. The bounded tangents keep controls in order
          // and within the sample range, preserving peaks and flat sections.
          d = (p.x - before.x) * 0.42,
          softness = 0.5;
        return ` C ${before.x + d},${before.y + d * tangents[i]! * softness} ${p.x - d},${p.y - d * tangents[i + 1]! * softness} ${p.x},${p.y}`;
      })
      .join("")
  );
}
